const _ = require('lodash')

const state = {
    today: 0,
    early: 0,
    live: 0,
    mixParlay: 0,
    focusedCount: 0,
    FGLG: 0,
    FT1X2: 0,
    FTCS: 0,
    FTHDP: 0,
    FTML: 0,
    HTML: 0,
    FTOE: 0,
    FTOU: 0,
    HT1X2: 0,
    HTCS: 0,
    HTFT: 0,
    HTHDP: 0,
    HTOE: 0,
    HTOU: 0,
    TG: 0,
    hackedWidth: 0,
    cssWidthOfMarket: 125
};

const mutations = {
    SET_DATE: (state, params) => {
        state[params.index] = params.count;
    },
    SET_MARKET: (state, params) => {
        if(params.count > 0){
            state.hackedWidth = state.hackedWidth + state.cssWidthOfMarket
        }
        state[params.index] = params.count;
    },
    RESET_COUNTS: (state) => {
        state.today = 0;
        state.early = 0;
        state.live = 0;
        state.mixParlay = 0;
        state.focusedCount = 0;
        state.FGLG = 0;
        state.FT1X2 = 0;
        state.FTCS = 0;
        state.FTHDP = 0;
        state.FTML = 0;
        state.HTML = 0;
        state.FTOE = 0;
        state.FTOU = 0;
        state.HT1X2 = 0;
        state.HTCS = 0;
        state.HTFT = 0;
        state.HTHDP = 0;
        state.HTOE = 0;
        state.HTOU = 0;
        state.TG = 0;
        state.hackedWidth = 0;
    },
    RESET_HACKED_WIDTH: (state) => {
        state.hackedWidth = 0;
    }
};

const actions = {
    newCounts({commit}, params) {
        commit('RESET_COUNTS');
        _.forEach(params.dates, (count, index) => {
            commit('SET_DATE', {index, count})
        })
        commit('RESET_HACKED_WIDTH')
        _.forEach(params.markets, (count, index) => {
            commit('SET_MARKET', {index, count})
        })
    }
};

const getters = {
    today: state => state.today,
    early: state => state.early,
    live: state => state.live,
    focusedCount: state => state.focusedCount,
    firstDateWithMatch: state => {
        let defaultDate = 'today'
        if(state.today === 0 && state.early>0){
            defaultDate = 'early'
        }
        return defaultDate
    },
    firstMarket: state => {
        if(state.FTHDP > 0){ return 'a'}
        else if(state.HTHDP > 0){ return 'b'}
        else if(state.FT1X2 > 0){ return 'c'}
        else if(state.HT1X2 > 0){ return 'd'}
        else if(state.FTCS > 0){ return 'e'}
        else if(state.HTCS > 0){ return 'f'}
        else if(state.FGLG > 0){ return 'g'}
        else if(state.HTFT > 0){ return 'h'}
        else if(state.FTML > 0){ return 'i'}
        else if(state.HTML > 0){ return 'j'}
        else if(state.FTOE > 0){ return 'k'}
        else if(state.HTOE > 0){ return 'l'}
        else if(state.FTOU > 0){ return 'm'}
        else if(state.HTOU > 0){ return 'n'}
        else if(state.TG > 0){ return 'o'}
    },
    mixParlay: state => state.mixParlay,
    availableMarketList: (state) => {
        let orderedMarkets = {}
        if(state.FTHDP > 0){ _.assign(orderedMarkets, {a : {name: "FTHDP", value: state.FTHDP, component: 'FH_THDP'}})}
        if(state.HTHDP > 0){ _.assign(orderedMarkets, {b : {name: "HTHDP", value: state.HTHDP, component: 'FH_THDP'}})}
        if(state.FT1X2 > 0){ _.assign(orderedMarkets, {c : {name: "FT1X2", value: state.FT1X2, component: 'FH_T1X2'}})}
        if(state.HT1X2 > 0){ _.assign(orderedMarkets, {d : {name: "HT1X2", value: state.HT1X2, component: 'FH_T1X2'}})}
        if(state.FTCS > 0){ _.assign(orderedMarkets, {e : {name: "FTCS", value: state.FTCS, component: 'FH_TCS'}})}
        if(state.HTCS > 0){ _.assign(orderedMarkets, {f : {name: "HTCS", value: state.HTCS, component: 'FH_TCS'}})}
        if(state.FGLG > 0){ _.assign(orderedMarkets, {g : {name: "FGLG", value: state.FGLG, component: 'FGLG'}})}
        if(state.HTFT > 0){ _.assign(orderedMarkets, {h : {name: "HTFT", value: state.HTFT, component: 'HTFT'}})}
        if(state.FTML > 0){ _.assign(orderedMarkets, {i : {name: "FTML", value: state.FTML, component: 'FH_TML'}})}
        if(state.HTML > 0){ _.assign(orderedMarkets, {j : {name: "HTML", value: state.HTML, component: 'FH_TML'}})}
        if(state.FTOE > 0){ _.assign(orderedMarkets, {k : {name: "FTOE", value: state.FTOE, component: 'FH_TOE'}})}
        if(state.HTOE > 0){ _.assign(orderedMarkets, {l : {name: "HTOE", value: state.HTOE, component: 'FH_TOE'}})}
        if(state.FTOU > 0){ _.assign(orderedMarkets, {m : {name: "FTOU", value: state.FTOU, component: 'FH_TOU'}})}
        if(state.HTOU > 0){ _.assign(orderedMarkets, {n : {name: "HTOU", value: state.HTOU, component: 'FH_TOU'}})}
        if(state.TG > 0){ _.assign(orderedMarkets, {o : {name: "TG", value: state.TG, component: 'TG'}})}
        return orderedMarkets
    },
    cssWidthOfMarket: state => state.cssWidthOfMarket,
    hackedWidth: state => state.hackedWidth,
    hackedWidthWhenRow: state => state.hackedWidth - 30,
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};